import { useAppDispatch, useAppSelector } from 'hooks';
import { useEffect } from 'react';
import {
  botMessageReceived,
  selectVisibleWidgetComponentCount,
} from 'reducers/workflows';

export default function useAnnounceMessageReceived() {
  const dispatch = useAppDispatch();
  const visibleWidgetComponentCount = useAppSelector(
    selectVisibleWidgetComponentCount,
  );

  useEffect(() => {
    // `> 1` because we don't want to trigger it for the greeting message:
    if (visibleWidgetComponentCount > 1) {
      dispatch(botMessageReceived());
    }
  }, [visibleWidgetComponentCount, dispatch]);
}
